import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';


export default class PortalFollwers extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    
    this.state = {
      friends: [],
      followers: [],
      following: {
        status: 0,
        notification: 1,
      },
		};
    this.getFollowers = this.getFollowers.bind(this);
    this.follow = this.follow.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
    value.setTheme( getUser );
		//const y = await value.setWorker( this.props.service );
		//let server = value.worker[this.props.service] || y[this.props.service];

    
    /*if( x.status === 200 ) {
      this.setState({status: true, account: x.data.account?x.data.account:{}, profile: x.data.profile?x.data.profile:{}});
    }*/

		EventEmitter.emit('/client', '');
		
		await this.getFollowers();
		
	}

  componentWillUnmount() {
    
	}

  async getFollowers() {
    let params = new URLSearchParams();
		params.append('uid', this.props.uid);
		const x = await postApi(`/v3/account/followers`, params);
    console.log(x.data);
    if( this.props.returnFollowers ) this.props.returnFollowers({friends: x.data.friends.length, followers: x.data.followers.length});
  }

  async follow(status, notification) {
    this.setState({following: {status, notification}});
    let params = new URLSearchParams();
		params.append('uid', this.props.uid);
    params.append('status', status);
    params.append('notification', notification);
		await putApi(`/v3/account/followers`, params);
    await this.getFollowers();
  }
	

  render() {
    const user = this.context;
    //console.log(user.user.user.id, this.props.uid, user.user.admin);

    
    
		return (
      
      <div className="d-flex flex-wrap align-items-center">
        {this.props.username && (user.user.user.id === this.props.uid || user.user.admin) &&
          <><Link to={user.user.user.id !== this.props.uid?`/settings/${this.props.username}`:'/settings'}><button type="button" className="btn btn-primary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="gear" /> Settings</button></Link>&nbsp;</>
        }
        <button type="button" className="btn btn-secondary btn-sm btn-wave waves-effect waves-light" onClick={()=>this.follow(1-this.state.following.status, this.state.following.notification)}><FontAwesomeIcon icon="plus" /> Follow</button>&nbsp;
        <button type="button" className="btn btn-secondary btn-sm btn-wave waves-effect waves-light" onClick={()=>this.follow(this.state.following.status, 1-this.state.following.notification)} disabled={this.state.following.status===0}><FontAwesomeIcon icon="plus" /> Notifications</button>
      </div>
      
    )
  }

}